var lib_core = require("lib-core");
var ui_extensions      = require("ui-extensions");
var UserSettingsModel = require("./userSettingsModel.js");
var cio_config = require("cio-config");

var UserSettingsController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};

lib_core.inherit(UserSettingsController, lib_core.Controller);

UserSettingsController.inject = { };
if(ui_extensions.OptionsController) {
    UserSettingsController.inject.optionsController = ui_extensions.OptionsController;
}

module.exports = UserSettingsController;

UserSettingsController.prototype.afterBuild = function () {
    
    if(this.optionsController) {
        var elements = [];
        
        elements.push({
            label: 'Units',
            type: ui_extensions.InspectorInputType.SELECTBOX,
            datamember : this.getModel().distanceUnit,
            list: cio_config.UnitConversions.getDistanceInspectorNames()
        });
        
        this.optionsController.addOptionGroup(elements);
    }
};

UserSettingsController.prototype.createModel = function () {
    return new UserSettingsModel(this.root, this.configuration);
};

